import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Tool = ({
  width = 32,
  height = 32,
  className,
  color,
  decorative = false,
  ariaLabel = "Tool",
}: IconProps) => {
  const classes = createColorClasses({ color });
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 32 32"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        d="M8.134 6a6.1 6.1 0 0 1 2.667-.667 6.13 6.13 0 0 1 3.066.8 5.87 5.87 0 0 1 2.667 5.334 2.4 2.4 0 0 0 .667 2.133l8.4 8.4a2.67 2.67 0 0 1 .4 3.467 2.53 2.53 0 0 1-2.134 1.2 2.67 2.67 0 0 1-1.866-.8l-8.534-8.534a3.2 3.2 0 0 0-1.866-.666h-.8a5.87 5.87 0 0 1-4-1.6 7.2 7.2 0 0 1-1.334-2.4h4.667v-2.8h-4.8A5.47 5.47 0 0 1 8.134 6m4.933 1.333a4.13 4.13 0 0 0-2.266-.666 3.73 3.73 0 0 0-2 .533 3.6 3.6 0 0 0-1.467 1.333h4.133V14h-3.6a3.73 3.73 0 0 0 2.934 1.333h.8a4 4 0 0 1 2.8 1.067l8.533 8.533a1.2 1.2 0 0 0 .933.4c.445-.03.845-.28 1.067-.666a1.33 1.33 0 0 0-.267-1.734l-8.4-8.4a4 4 0 0 1-1.066-3.2 4.13 4.13 0 0 0-2.134-4"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};


